export default {
  locale: 'nl_NL',
  language: 'nl',
  otherLanguages: ['en', 'de'],
  languageCode: 'nl-NL',
  currency: 'Euro',
  currencyShort: 'EUR',
  currencySymbol: '€',
}
